module.exports = __webpack_public_path__ + "img/BCH.b5be2bf5.png";